import classNames from "classnames";
import { memo } from "react";

import styles from "./RadioDescription.module.scss";

type RadioDescriptionProps = {
  readonly copy: string;
};

export const RadioDescription = memo<RadioDescriptionProps>(({ copy }) => (
  <small className={classNames(styles.label)}>{copy}</small>
));
